import React from "react";
import TagStats from "./TagStats";
import ZapButtons from "./ZapButtons";
import { IconButton, Tooltip, useTheme } from "@material-ui/core";
import { FileCopyTwoTone } from "@material-ui/icons";

const FormAddtionalHeaders = ({
  targetingID,
  publisherChannelStats,
  activityLog,
  historyPage,
  setHistoryPage,
  historyLimit,
  totalHistoryCount,
  isLatestHistoryLoading,
  setStartFetchHistory,
  handlePublisherLinkLookerStudio,
  duplicateTargetingLink
}) => {
  const theme = useTheme();
  return (
    <>
      <ZapButtons targetingID={targetingID} />
      {publisherChannelStats.data?.publisher_channel_id ? (
        <>
          <button
            onClick={() => {
              duplicateTargetingLink(
                publisherChannelStats.data.publisher_channel_id
              );
            }}
            style={{
              marginRight: "10px",
              border: "none",
              background: "none"
            }}
          >
            <Tooltip title="Duplicate targeting">
              <IconButton>
                <FileCopyTwoTone style={{ fill: theme.palette.primary.main }} />
              </IconButton>
            </Tooltip>
          </button>
        </>
      ) : null}
      <TagStats
        publisherChannelStats={publisherChannelStats}
        handlePublisherLinkLookerStudio={handlePublisherLinkLookerStudio}
        activityLog={activityLog}
        tableType="PublisherLatestHistory"
        targetingID={targetingID}
        historyPage={historyPage}
        setHistoryPage={setHistoryPage}
        historyLimit={historyLimit}
        totalHistoryCount={totalHistoryCount}
        isLatestHistoryLoading={isLatestHistoryLoading}
        setStartFetchHistory={setStartFetchHistory}
      />
    </>
  );
};

export default FormAddtionalHeaders;
